import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { exportMultipleChartsToPdf, generateExcel } from "../../../../utils/pdf";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../../SvgIconsData";
import ProPopup from "../../../layouts/ProPopup";

const GroupReport = ({ dates={ start: null, end: null }, type=0, groupId, typeName, filter, setParentLoading, setDropdownGroupList }) => {

  const [subGroupsList, setSubGroupsList] = useState([]);
  const [mainGroupData, setMainGroupData] = useState({});
  const [userReportData, setuserData] = useState([]);
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [userPlan, setUserPlan] = useState(null);
  const [openPro, setOpenPro] = useState(false);

  useEffect(() => {
    userPlan && !userPlan.report.group && setOpenPro(true);
  }, [userPlan]);

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const getGroupsList = async () => {
    try {
      setLoading(true);
      setParentLoading(true);

      let url = `${configData.config.API_URL}/api/analytics/${typeName}/${groupId}`;
      if (dates.start && dates.end) {
        url += `?start=${dates.start.toISOString()}&end=${dates.end.toISOString()}`;
      }

      let { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      setSubGroupsList(data.data.subGroups || []);
      setDropdownGroupList(data.data.subGroups || []);
      setMainGroupData(data.data.mainGroup || {});
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false);
      setParentLoading(false)
    }
  };


  const handleMaingroupPdf = () => {
    const tableData1 = [
      ["Group Details", ""],
      ["Name", mainGroupData?.name],
      ["Total User", mainGroupData?.totalUserCount || 0],
      ["Guided user", mainGroupData?.uniqueGuidedUserCount || 0],
      ["Unguided User", mainGroupData?.uniqueUnguidedUserCount || 0],
      ["Certified User", mainGroupData?.certificate || 0],
    ];
    const groupsData = [];

    for (var i = 0; i < subGroupsList.length; i++) {
      groupsData.push([
        subGroupsList[i].name,
        subGroupsList[i].totalUserCount,
        subGroupsList[i].uniqueGuidedUserCount,
        subGroupsList[i].uniqueUnguidedUserCount,
        subGroupsList[i].certificate,
      ]);
    }

    const tableData2 = [
      ["Group Name", "Total User", "Guided User", "Unguided User", "Certified User"],
      ...groupsData,
    ];

    let arr = [];

    for (var i = 0; i < userReportData.length; i++) {
      arr.push([
        i + 1,
        userReportData[i].name,
        userReportData[i].guided,
        userReportData[i].unguided,
        userReportData[i].certificate.length,
      ]);
    }

    const tableData3 = [
      ["S.No.", "Name", "Guided Count", "UnGuided Count", "Certfications"],
      ...arr,
    ];
    exportMultipleChartsToPdf("Main_Location_Wise", tableData1, tableData2, tableData3);
  };

  const handleMaingroupExcel = () => {
    const tableData1 = [
      ["Group Details", ""],
      ["Name", mainGroupData?.name],
      ["Total User", mainGroupData?.totalUserCount || 0],
      ["Guided user", mainGroupData?.uniqueGuidedUserCount || 0],
      ["Unguided User", mainGroupData?.uniqueUnguidedUserCount || 0],
      ["Certified User", mainGroupData?.certificate || 0],
    ];
    const groupsData = [];

    for (var i = 0; i < subGroupsList.length; i++) {
      groupsData.push([
        subGroupsList[i].name,
        subGroupsList[i].totalUserCount,
        subGroupsList[i].uniqueGuidedUserCount,
        subGroupsList[i].uniqueUnguidedUserCount,
        subGroupsList[i].certificate,
      ]);
    }

    const tableData2 = [
      ["Group Name", "Total User", "Guided User", "Unguided User", "Certified User"],
      ...groupsData,
    ];

    let arr = [];

    for (var i = 0; i < userReportData.length; i++) {
      arr.push([
        i + 1,
        userReportData[i].name,
        userReportData[i].guided,
        userReportData[i].unguided,
        userReportData[i].certificate.length,
      ]);
    }

    const tableData3 = [
      ["S.No.", "Name", "Guided Count", "UnGuided Count", "Certfications"],
      ...arr,
    ];
    generateExcel("Group_Location_Wise", tableData1, tableData2, tableData3);
  };

  const handlePdfSubGroup = (item) => {
    const tableData1 = [
      ["Group Details", ""],
      ["Name", item?.name],
      ["Total User", item?.totalUserCount || 0],
      ["Guided user", item?.uniqueGuidedUserCount || 0],
      ["Unguided User", item?.uniqueUnguidedUserCount || 0],
      ["Certified User", item?.certificate || 0],
    ];

    exportMultipleChartsToPdf("User_Location_Wise", tableData1);
  };

  const handleExcelSubGroup = (item) => {
    const tableData1 = [
      ["Group Details", ""],
      ["Name", item?.name],
      ["Total User", item?.totalUserCount || 0],
      ["Guided user", item?.uniqueGuidedUserCount || 0],
      ["Unguided User", item?.uniqueUnguidedUserCount || 0],
      ["Certified User", item?.certificate || 0],
    ];

    generateExcel("SubGroup_Location_Wise", tableData1);
  };

  useEffect(() => {
    if(userPlan?.report?.group){
      getGroupsList();
    }
  }, [userPlan,type, groupId, dates]);

  const filteredGroups = subGroupsList.filter(
    (item) =>
      filter.length === 0 ||
      filter.some((word) => item.name.toLowerCase() == word.name.toLowerCase())
  );

  return (
    <>
      <div className="table-responsive workflowtb mt-2 stickyhead reports">
              <table className="table align-middle table-nowrap mb-0">
                <thead>
                  <tr>
                    <th> <div className="text-center">S.No.</div> </th>

                    <th> <span className="d-flex align-items-center justify-content-start gap-1" onClick={ type == 0 ? () => handleSort("name") : null }> Group Name  </span> </th>

                    <th className="text-center">   <span className="d-flex align-items-center justify-content-center gap-1"> Total Users </span> </th>

                    <th className="text-center">
                        <span className="d-flex align-items-center justify-content-center gap-1">
                           {type == 0 ? "Guided Users" : "All"}
                        </span>
                    </th>

                    <th className="text-center">
                        <span className="d-flex align-items-center justify-content-center gap-1">
                           { type == 0 ? "Unguided Users" : "Guided" }
                        </span>
                    </th>

                    <th className="text-center">
                        <span className="d-flex align-items-center justify-content-center gap-1">
                          {type == 0 ? "Certified User" : "Unguided" }
                        </span>
                    </th>

                    <th className="text-center">
                      <span className="d-flex align-items-center justify-content-center gap-1 table-pro">
                        Download
                      </span>
                    </th>

                  </tr>
                </thead>

                <thead className="bottom-stuck top-stuck">
                    { loading ?
                      <tr>
                        {Array.from({length : 6}).map((_, index)=> <td className="text-center"> <Skeleton width="5vw" /> </td> )}
                        
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          {loading ?  
                              <Skeleton
                                width="40px"
                                height="33px"
                                baseColor="#3e4095"
                                highlightColor="#ffffff50"
                              />
                          :  
                              <button
                                // className="DefaultRedBtn download px-2 disabled"
                                className="DefaultRedBtn download px-2"
                                title="Download PDF"
                                onClick={()=>  userPlan?.report?.download ? handleMaingroupPdf() : setOpenPro(true) }
                                >
                                <PDFDownloadIcon />
                              </button>
                          }

                          {loading ? 
                            <Skeleton
                                width="40px"
                                height="33px"
                                baseColor="#3e4095"
                                highlightColor="#ffffff50"
                              />
                          : 
                          <button
                                // className="DefaultRedBtn download px-2 disabled"
                                className="DefaultRedBtn download px-2"
                                title="Download Excel"
                                onClick={()=>  userPlan?.report?.download ? handleMaingroupExcel() : setOpenPro(true) }>
                                <EXLDownloadIcon />
                              </button>
                          }
                        </td>
                      </tr>
                      :
                      <tr>
                        

                        <td className="text-center">
                          {loading ?  <Skeleton width="5vw" /> : "#" }
                        </td>
                        <td>

                          {loading ? <Skeleton width="5vw" /> : mainGroupData?.name || "" }
                        </td>

                        <td className="text-center">
                          {loading ? <Skeleton width="5vw" /> :  mainGroupData?.totalUserCount || 0  }
                        </td>

                        <td className="text-center">
                          {loading ? <Skeleton width="5vw" />
                              : 
                          type == 0 ? mainGroupData?.uniqueGuidedUserCount || 0
                              : 
                            mainGroupData?.all || 0
                          }
                          
                        </td>
                        <td className="text-center">
                          {loading ? <Skeleton width="5vw" /> : 
                            type == 0 ? mainGroupData?.uniqueUnguidedUserCount || 0 
                              : 
                              mainGroupData?.guided || 0
                          }
                            
                        </td>
                        <td className="text-center">
                          {loading ?  <Skeleton width="5vw" /> :
                              type == 0 ?  mainGroupData?.certificate || 0 :  mainGroupData?.unguided || 0
                          }
                        </td>
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          {loading ?  
                              <Skeleton
                                width="40px"
                                height="33px"
                                baseColor="#3e4095"
                                highlightColor="#ffffff50"
                              />
                          :  
                              <button
                                // className="DefaultRedBtn download px-2 disabled"
                                className="DefaultRedBtn download px-2"
                                title="Download PDF"
                                onClick={()=>  userPlan?.report?.download ? handleMaingroupPdf() : setOpenPro(true) }
                                >
                                <PDFDownloadIcon />
                              </button>
                          }

                          {loading ? 
                            <Skeleton
                                width="40px"
                                height="33px"
                                baseColor="#3e4095"
                                highlightColor="#ffffff50"
                              />
                          : 
                          <button
                                // className="DefaultRedBtn download px-2 disabled"
                                className="DefaultRedBtn download px-2"
                                title="Download Excel"
                                onClick={()=>  userPlan?.report?.download ? handleMaingroupExcel() : setOpenPro(true) }>
                                <EXLDownloadIcon />
                              </button>
                          }
                        </td>
                      </tr>
                  }
                </thead>

                {!loading ? (
                  <tbody>
                    {filteredGroups.length > 0 &&
                      filteredGroups.map((item, index) => {
                        return (
                          <>
                            <tr>
                              <td>
                                <div className="text-center">{index + 1}</div>
                              </td>
                              <td onClick={() => navigate(`/reports/${item.uuid}`)}>
                                 <a> {item?.name}</a>
                              </td>
                              <td className="text-center">
                                {type == 0 ? item?.totalUserCount : item?.totalUserCount || 0}
                              </td>
                              <td className="text-center">
                                {type == 0 ? item?.uniqueGuidedUserCount : item?.all || 0}
                              </td>
                              <td className="text-center">
                                {type == 0 ? item?.uniqueUnguidedUserCount : item?.guided || 0}
                              </td>
                              <td className="text-center">
                                {type == 0 ? item?.certificate : item?.unguided || 0}
                              </td>
                              <td className="d-flex align-items-center justify-content-center gap-2">
                                <button
                                  className="DefaultRedBtn download px-2"
                                  title="Download PDF"
                                  onClick={() => userPlan?.report?.download ? handlePdfSubGroup(item) : setOpenPro(true) }>
                                  <PDFDownloadIcon />
                                </button>
                                <button
                                  className="DefaultRedBtn download px-2"
                                  title="Download Excel"
                                  onClick={() => userPlan?.report?.download ? handleExcelSubGroup(item) : setOpenPro(true) }>
                                  <EXLDownloadIcon />
                                </button>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                  </tbody>
                ) : (
                  <>
                    <tbody>
                      {Array.from({length:5}).map((_, index)=>(
                          <tr>
                            {Array.from({length:6}).map((_, index)=> <td> <Skeleton width="5vw" /> </td> )}
                            <td className="d-flex align-items-center justify-content-center gap-2">
                              <Skeleton
                                width="40px"
                                height="33px"
                                baseColor="#3e4095"
                                highlightColor="#ffffff50"
                              />

                              <Skeleton
                                width="40px"
                                height="33px"
                                baseColor="#3e4095"
                                highlightColor="#ffffff50"
                              />
                            </td>
                          </tr>
                      ))}
                    </tbody>
                  </>
                )}

                <thead className="bottom-stuck">
                  <tr>
                    {loading ? 
                     Array.from({length : 7}).map((_, index)=> <td className="text-center"> <Skeleton width="5vw" /> </td> )
                    :
                    <>
                    <td className="text-center"> </td>
                    <td> Total</td>
                    <td className="text-center">
                    {filteredGroups.reduce(
                            (acc, current) =>
                              acc + (type == 0 ? current?.totalUserCount : current?.totalUserCount),
                            0
                          ) || 0}
                    </td>
                    <td className="text-center">
                    {filteredGroups.reduce(
                            (acc, current) =>
                              acc + (type == 0 ? current?.uniqueGuidedUserCount : current?.all),
                            0
                          ) || 0}
                    </td>
                    <td className="text-center">
                    {filteredGroups.reduce(
                            (acc, current) =>
                              acc +
                              (type == 0 ? current?.uniqueUnguidedUserCount : current?.guided),
                            0
                          ) || 0}
                    </td>
                    <td className="text-center">
                    {filteredGroups.reduce(
                            (acc, current) =>
                              acc + (type == 0 ? current?.certificate : current?.unguided),
                            0
                          ) || 0}
                    </td>
                    <td className=""> </td>
                    </>
                 }
                  </tr>
                </thead>

              </table>
      </div>

      <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>
  );
};

export default GroupReport;